
  module.exports = [
    {
      id: "dealOwner", // V-Model Name
      fieldName: "Deal Owner", // Field Name
    },
    {
      id: "dealName",
      fieldName: "Deal Name",
    },
    {
      id:"stage",
      fieldName:"Stage"
    }
  ];